// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 5651 ? "web" : chunkId) + "." + {"2736":"d35b4e88ee82ae3bd6eb","4676":"13e7a8937631d6310ca6","5651":"0d9de9feab1aff17278e","5872":"95040ec65f37592c0c9b"}[chunkId] + ".css";
};